import { gql } from '@apollo/client';
import { API_FIELDS_CONTACT as CONTACT, CONTACT_CLASSIFICATION, API_FIELDS_STUDENT_FAMILY as STUDENT_FAMILY } from '@enroller/admissions-components';
import { createNestedPayload, createStringPayload } from '../utils/formatSchema';
import { ModuleLayout, PUT_API_MODULE_NAMES } from '@enroller/utils';

export const STUDENT_FAMILY_FIELDS = [STUDENT_FAMILY.ID, STUDENT_FAMILY.houseType, STUDENT_FAMILY.maritalStatus, STUDENT_FAMILY.otherMaritalStatus];

const STUDENT_FAMILY_CONTACTS_FIELDS = [
  CONTACT.ID,
  CONTACT.firstName,
  CONTACT.lastName,
  CONTACT.email,
  CONTACT.mobile,
  CONTACT.country,
  CONTACT.state,
  CONTACT.city,
  CONTACT.addressLine2,
  CONTACT.postalCode,
  CONTACT.addressLine1,
  CONTACT.gender,
  CONTACT.workPhone,
  CONTACT.phone,
  CONTACT.occupation,
  CONTACT.relationship,
  CONTACT.isLegalGuardian,
  CONTACT.parentStatus,
  CONTACT.contactClassification,
  CONTACT.age,
];

export const STUDENT_FAMILY_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
          Student_Family {
            ${createStringPayload(STUDENT_FAMILY_FIELDS)}
          }
        }
      }
    }
  }
`;

export const STUDENT_FAMILY_CONTACTS_QUERY = gql`
  query StudentApp($studentFamilyId: String!) {
    Records {
      Accounts(where: { id: { equals: $studentFamilyId } }) {
        _data {
          ${createNestedPayload(STUDENT_FAMILY.contactListGet, STUDENT_FAMILY_CONTACTS_FIELDS)}
        }
      }
    }
  }
`;

export type StudentFamilyPayloadFields = {
  [STUDENT_FAMILY.ID]?: string;
  [STUDENT_FAMILY.houseType]: string[];
  [STUDENT_FAMILY.maritalStatus]: string;
  [STUDENT_FAMILY.otherMaritalStatus]: string;
  layout?: ModuleLayout;
};

export interface StudentFamilyContactsBasePayloadFields {
  [CONTACT.ID]?: string;
  [CONTACT.firstName]?: string;
  [CONTACT.lastName]?: string;
  [CONTACT.contactClassification]: CONTACT_CLASSIFICATION;
}

export interface ParentsPayload extends StudentFamilyContactsBasePayloadFields {
  [CONTACT.gender]?: string;
  [CONTACT.isLegalGuardian]?: boolean;
  [CONTACT.occupation]?: string;
  [CONTACT.mobile]?: string;
  [CONTACT.workPhone]?: string;
  [CONTACT.email]?: string;
  [CONTACT.parentStatus]?: string;
  [CONTACT.country]?: string;
  [CONTACT.state]?: string;
  [CONTACT.city]?: string;
  [CONTACT.addressLine2]?: string;
  [CONTACT.postalCode]?: string;
  [CONTACT.addressLine1]?: string;
}

export interface FamilyMemberPayload extends StudentFamilyContactsBasePayloadFields {
  [CONTACT.relationship]?: string;
  [CONTACT.age]?: string;
  [CONTACT.gender]?: string;
}

export interface FriendsInUSAPayload extends StudentFamilyContactsBasePayloadFields {
  [CONTACT.relationship]?: string;
  [CONTACT.email]?: string;
  [CONTACT.phone]?: string;
  [CONTACT.country]?: string;
  [CONTACT.state]?: string;
  [CONTACT.city]?: string;
  [CONTACT.addressLine2]?: string;
  [CONTACT.postalCode]?: string;
  [CONTACT.addressLine1]?: string;
}

export interface StudentFamilyContactsPayloadFields extends FriendsInUSAPayload, FamilyMemberPayload, ParentsPayload {}

export type StudentFamilyPayload = {
  data: {
    [PUT_API_MODULE_NAMES.ACCOUNTS]: StudentFamilyPayloadFields[];
    [PUT_API_MODULE_NAMES.CONTACTS]: StudentFamilyContactsPayloadFields[];
  };
  meta?: { [key: string]: string };
};

export type StudentFamilyRecordFields = {
  [STUDENT_FAMILY.ID]: { value?: string };
  [STUDENT_FAMILY.houseType]: { value?: string[] };
  [STUDENT_FAMILY.maritalStatus]: { value?: string };
  [STUDENT_FAMILY.otherMaritalStatus]: { value?: string };
};

export type StudentFamilyContactsRercordFields = {
  [CONTACT.ID]: { value?: string };
  [CONTACT.firstName]: { value?: string };
  [CONTACT.lastName]: { value?: string };
  [CONTACT.email]: { value?: string };
  [CONTACT.mobile]: { value?: string };
  [CONTACT.country]: { value?: string };
  [CONTACT.state]: { value?: string };
  [CONTACT.city]: { value?: string };
  [CONTACT.addressLine2]: { value?: string };
  [CONTACT.postalCode]: { value?: string };
  [CONTACT.addressLine1]: { value?: string };
  [CONTACT.gender]: { value?: string };
  [CONTACT.workPhone]: { value?: string };
  [CONTACT.phone]: { value?: string };
  [CONTACT.occupation]: { value?: string };
  [CONTACT.relationship]: { value?: string };
  [CONTACT.isLegalGuardian]: { value?: boolean };
  [CONTACT.parentStatus]: { value?: string };
  [CONTACT.age]: { value?: string };
  [CONTACT.contactClassification]: { value?: string };
};

export type StudentFamilyContactsFieldsResponse = {
  [STUDENT_FAMILY.contactListGet]: {
    _data: StudentFamilyContactsRercordFields[];
  };
};

export type StudentFamilyFieldsResponse = {
  Student_Family: StudentFamilyRecordFields;
};
